import request from '@/utils/request'

// 获取用户信息
export function getUserInfo() {
    return request({
        url: '/agent/personal/show-info',
        method: 'get',
    })
}

// 获取当前用户的代理列表
export function getPlanList() {
    return request({
        url: '/agent/regionPlans/planList',
        method: 'get'
    })
}

// 获取升级信息
export function getUpgradeInfo() {
    return request({
        url: '/agent/config/versionUpgradeNotice?port=H5_FAGENT',
        method: 'get'
    })
}



// WEBPACK FOOTER //
// ./src/api/mine.js